export const clone = <T>(value: T): T => {
  return structuredClone(value);
};
